var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      this.$store.get('systems@LoginData') &&
        this.$store.get('systems@LoginData').userName &&
        this.$store.get('systems@LoginData') != []
    )?_c('div',{staticClass:"offline-user-online text-align-center",style:({
      top: ((this.$store.get('systems@PageHeight') - 26) + "px"),
      width: "200px",
      left: ((this.$store.get('systems@PageWidth') - 210) + "px")
    })},[_c('v-icon',{staticClass:"icon-user-online",attrs:{"name":"user"}}),_vm._v(_vm._s(this.$store.get("systems@LoginData").userName)+"\n  ")],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }